//import '@googlemaps/js-api-loader';
//import "google-maps";
import vendor_gst_delivery_details from "./vendor_gst_delivery_details";
import vendor_Products_Services_details from "./vendor_Products_Services_details";
import { getVendorBusinessImageUrl } from "../helpers/mediaUrl";
var otp;
globalThis.userCreated = false;
var oldLat = 0;
var oldLong = 0;

var phnoEmailIsUnique;

//var map, marker;

export default class vendor_details {
  constructor() {
    this.formstep1 = $("#formstep1");
    this.formstep2 = $("#formstep2");
    this.formstep3 = $("#formstep3");
    this.formstep4 = $("#formstep4");
    this.formstep5 = $("#formstep5");

    this.basicDetailsAndAddressForm = $("#basicDetails-AddressForm1");
    this.inputBusinessName = $("#inputBusinessName");
    this.inputContactPersonName = $("#inputContactPersonName");
    this.inputPhoneNumber = $("#inputPhoneNumber");
    this.inputEmail1 = $("#inputEmail1");
    this.inputPassword = $("#inputPassword");
    this.inputAddress = $(".inputAddress");
    this.inputLandmark = $("#inputLandmark");
    this.inputCity = $(".inputCity");
    this.inputState = $(".inputState1");
    this.inputPincode = $("#inputPincode");

    this.submitBtn = $("#submitBtn");
    this.autoDetectBtn = $("#auto-detect-btn"); //location
    this.saveChangesBtn = $("#saveChangesBtn");

    this.businessNameError = $("#businessNameError");
    this.contactPersonNameError = $("#contactPersonNameError");
    this.phoneNumberError = $("#phoneNumberError");
    this.emailError = $("#emailError");
    this.passwordError = $("#passwordError");

    this.inputAddressError = $("#inputAddressError");
    this.inputLandmarkError = $("#inputLandmarkError");
    this.inputCityError = $("#inputCityError");
    this.inputStateError = $("#inputStateError");
    this.inputpincodeError = $("#inputpincodeError");
    this.BusinessImageError = $(".BusinessImageError");

    this.autoDetectModal = $("#locationModal");
    this.inputAdress = $("#inputAddress");

    this.inputState = $("#inputState");
    this.inputPincode = $("#inputPincode");
    this.venId = $("#venId");

    this.verifyOtpModal = $("#verifyOtpModal");
    this.OTPInputVerify = $("#otp-input-verify");
    this.OTPSuccess = $("#otpError");

    this.verifyOTPDetails = $("#verify-OTP-details");
    this.verifyOTPBtn = $("#verify-OTP-btn");
    this.resendOTPBtn = $("#resend-OTP-btn");

    this.basicDetails_page = $(".basicDetails-page");
    this.GSTDetails_page = $(".GSTDetails-page");

    this.gstPrevBtn = $("#gstPrevBtn");
    this.stem2submitBtn = $("#stem2submitBtn");

    this.Products_Services_page4 = $(".Products-Services-page4");

    this.otpInputVerify = $("#otpInputVerify");
    this.otpError = $("#otpError");
    this.verifyOtpModalClose = $("#verifyOtpModalClose");

    this.vendorCategoriesBox = $(".vendorCategoriesBox");
    this.vendorSpecialitiesBox = $(".vendorSpecialitiesBox");
    this.upload_form = $("#upload_form");

    // File input elements
    this.inpFileOne1 = document.getElementById("inpBusinessImg");
    this.inpFileOne = document.getElementById("inpBusinessImgPreview");
    
    // State variables
    this.vendorDocumentArray = [];
    this.img1flag = false;
    this.BusinessImage = null;
    this.imgSelected = false;
    this.newEditProductImages = [];
    this.savedVendorImg = "";
    this.vendorStatusFlag = false;

    // Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    //to check if vendor signup is pending and then integrate
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    var vendorStatus = urlParams.get("status");

    globalThis.userCreated = false;

    if (vendorStatus == "Pending") {
      globalThis.userCreated = true;
      this.signUpPending();
      this.vendorStatusFlag = true;
      this.GetAddress();
    } else {
      //Delete vendor_ID Session
      $.ajax({
        url: baseURL + "api/vendor/unsetSessionValuesVendor",
        type: "POST",
        data: {
          unset: "Vendor_ID",
        },
        success: (result) => {},
      });
    }

    globalThis.phnoEmailIsUnique = false;
    globalThis.prevPhoneNo = 0;
    globalThis.prevEmail = "old";

    new vendor_gst_delivery_details();
    new vendor_Products_Services_details();
    this.gstPrevBtn.on("click", this.doPrevAction);
    this.submitBtn.on("click", this.doFormAction);
    this.verifyOTPBtn.on("click", this.doVerifyOTP);
    this.resendOTPBtn.on("click", this.doResendOTPAction);

    const initMapsResiliently = () => {
      if (typeof google !== "undefined" && google.maps && google.maps.places) {
        this.initModal();
      } else {
        console.log("Locaso: Waiting for Google Maps to load...");
        setTimeout(initMapsResiliently, 500);
      }
    };
    if (document.readyState === "complete") {
      initMapsResiliently();
    } else {
      $(window).on("load", initMapsResiliently);
    }

    this.saveChangesBtn.on("click", this.closeModal);
    this.verifyOtpModalClose.on("click", this.closeOTPModal);

    if (this.inpFileOne1) {
      this.inpFileOne1.addEventListener("change", this.ImageValidate);
    }

    this.basicDetailsAndAddressForm.on(
      "focus",
      "input[type=number]",
      function (e) {
        $(this).on("wheel.disableScroll", function (e) {
          //
          e.preventDefault();
        });
      },
    );

    // Trigger cropper initialization on click before the file chooser opens
    $(document).on("click", ".imageCropInput", () => {
      if (globalThis.cropperMain) {
        globalThis.cropperMain.doCroppingAction();
      }
    });
  };

  signUpPending = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      // data: {
      // },
      headers: { Authorization: X_API_KEY },
      success: this.show_vendor_details,
    });
    // .done(function (res) {
    //
    //   this.show_vendor_details(res);
    // })
    // .fail(function (res) {
    //   if (res["status"] === 400) {
    //     console.error("Page not found");
    //   } else {
    //     console.error("Error: " + res["responseJSON"]["Msg"]);
    //   }
    // });
  };

  closeModal = () => {
    this.autoDetectModal.hide();
  };
  closeOTPModal = () => {
    // this.verifyOtpModal.hide();
    window.$("#verifyOtpModal").modal("hide");

    // this.otpInputVerify.val(" ");
  };

  doPrevAction = () => {
    // this.GSTDetails_page.addClass("d-none");
    this.vendorSpecialitiesBox.removeClass("d-none");
    this.formstep3.removeClass("current-item");
    this.GSTDetails_page.addClass("d-none");
    this.formstep2.addClass("current-item");
    // this.formstep2.addClass("current-item");
    // this.formstep4.addClass("current-item");
  };

  // doVerifyOTP = () => {
  //   this.verifyOTPDetails.addClass("d-none");
  //   this.submitBtn.removeClass("d-none");
  // };

  doFormAction = async (e) => {
    phnoEmailIsUnique = false;
    e.preventDefault();

    this.ImageValidate();
    if (this.imgSelected) {
      this.BusinessImageError.html("");
    } else {
      $("#collapseOne-1").addClass("show");

      this.BusinessImageError.html("Please select an image.");
    }

    // Validate lat/lon from map selection
    let latValue = $("#inputLat").val();
    let lonValue = $("#inputlong").val();
    let isLatLonValid =
      latValue && lonValue && latValue.trim() !== "" && lonValue.trim() !== "";

    if (!isLatLonValid) {
      $("#collapseTwo-1").addClass("show");
      this.inputAddressError.html("Please select a location from the map.");
    }

    let isAddressValidated = this.Address_validate();
    if (isAddressValidated) {
      this.inputAddressError.html("");
    }

    let isCityValidated = this.City_validate();
    if (isCityValidated) {
      this.inputCityError.html("");
    }

    let isPincodeValidated = this.Pincode_validate();
    if (isPincodeValidated) {
      this.inputpincodeError.html("");
    }

    let isBusinessNameValidated = this.BusinessName_validate();
    if (isBusinessNameValidated) {
      this.businessNameError.html("");
    }

    let isContactPersonNameValidated = this.ContactPersonName_validate();
    if (isContactPersonNameValidated) {
      this.contactPersonNameError.html("");
    }

    let isPhValidated = this.Phno_validate();
    if (isPhValidated) {
      this.phoneNumberError.html("");
    } else {
    }

    let isEmailValidated = this.Email_validate();
    if (isEmailValidated) {
      this.emailError.html("");
    }

    let isPasswordValidated = false;

    if (globalThis.userCreated) {
      isPasswordValidated = true;
    } else {
      isPasswordValidated = this.Password_validate();
      if (isPasswordValidated) {
        this.passwordError.html("");
      }
    }

    if (true) {
      await this.phnoEmailIsUnique_validate();

      if (phnoEmailIsUnique && this.Phno_validate()) {
        this.emailError.html("");
        this.phoneNumberError.html("");
      }
    }

    if (
      isBusinessNameValidated &&
      isContactPersonNameValidated &&
      isPhValidated &&
      isEmailValidated &&
      isPasswordValidated &&
      isAddressValidated &&
      isCityValidated &&
      isPincodeValidated &&
      isLatLonValid &&
      phnoEmailIsUnique &&
      this.imgSelected &&
      this.img1flag
    ) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/SendOTPSignUp",

        headers: { Authorization: X_API_KEY },

        data: {
          Phone_Number: $("#inputPhoneNumber").val(),
          Email_Address: $("#inputEmail1").val(),
        },
        success: (data) => {
          otp = data["OTP"];
          setTimeout(() => {
            this.OTPSuccess.addClass("text-danger");

            this.OTPSuccess.html("OTP has expired, Try again.");
            otp = null;
          }, 600000);
        },
        error: (err) => {},
      });
      this.OTPSuccess.html(" ");
      // this.otpInputVerify.val(" ");
      // this.verifyOtpModal.show();
      window.$("#verifyOtpModal").modal("show");
      // this.Submit_Form();
    }
  };

  phnoEmailIsUnique_validate = async () => {
    if (
      globalThis.prevPhoneNo == this.inputPhoneNumber.val() &&
      globalThis.prevEmail == this.inputEmail1.val()
    ) {
      phnoEmailIsUnique = true;
    } else {
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/CheckPhNoEmailExists",

          headers: { Authorization: X_API_KEY },

          data: this.basicDetailsAndAddressForm.serialize(),
          statusCode: {
            400: function () {
              alert("400 status code! user error");
              resolve();
            },
            500: function () {
              alert("500 status code! server error");
              resolve();
            },
          },
          success: (res) => {
            this.CheckPhNoEmailExistsSuccess(res);
            resolve();
          },
          error: resolve,
        });
      });
    }
  };

  CheckPhNoEmailExistsSuccess = (res) => {
    let retCode = res.Code;

    if (retCode == 6) {
      $("#collapseOne-1").addClass("show");

      this.phoneNumberError.html(
        "Phone Number already exists. Kindly Login to Continue",
      );
      if (globalThis.prevPhoneNo == this.inputPhoneNumber.val()) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 7) {
      $("#collapseOne-1").addClass("show");

      this.emailError.html("Email already exists");

      if (globalThis.prevEmail == this.inputEmail1.val()) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 8) {
      // this.emailError.html("Email and PhoneNo already exists");
      if (globalThis.prevPhoneNo != this.inputPhoneNumber.val()) {
        $("#collapseOne-1").addClass("show");

        this.phoneNumberError.html(
          "Phone Number already exists. Kindly Login to Continue",
        );
      }
      if (globalThis.prevEmail != this.inputEmail1.val()) {
        $("#collapseOne-1").addClass("show");

        this.emailError.html("Email already exists");
      }
      if (
        globalThis.prevPhoneNo == this.inputPhoneNumber.val() &&
        globalThis.prevEmail == this.inputEmail1.val()
      ) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 0) {
      // this.emailError.html("Email already exists");

      phnoEmailIsUnique = true;
    }
  };

  //validate function

  BusinessName_validate = () => {
    let flag = true;

    if (
      !(
        this.inputBusinessName.val().length >= 2 &&
        this.inputBusinessName.val().length <= 100
      )
    ) {
      $("#collapseOne-1").addClass("show");

      this.businessNameError.html(
        "Business Name must be min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  ContactPersonName_validate = () => {
    let flag = true;
    var contactname = /^[a-z ,.'-]+$/i;
    if (
      !(
        this.inputContactPersonName.val().length >= 2 &&
        this.inputContactPersonName.val().length <= 100
      ) ||
      !this.inputContactPersonName.val().match(contactname)
    ) {
      $("#collapseOne-1").addClass("show");

      this.contactPersonNameError.html(
        "Contact Person Name must min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  Phno_validate = () => {
    let flag = true;
    // var phoneno = /^\d{10}$/;
    var phoneno = /^[1-9]{1}[0-9]{9}$/;
    if (!this.inputPhoneNumber.val().match(phoneno)) {
      $("#collapseOne-1").addClass("show");

      this.phoneNumberError.html(
        "Please enter only 10 digits for mobile number",
      );

      flag = false;
    }

    return flag;
  };

  Email_validate = () => {
    let flag = true;
    var emailexample =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.inputEmail1.val().match(emailexample)) {
      $("#collapseOne-1").addClass("show");

      this.emailError.html("Please enter a valid email");

      flag = false;
    }

    return flag;
  };

  Password_validate = () => {
    //
    // let flag = true;
    // var PasswordExample =
    //   /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

    // if (!this.inputPassword.val().match(PasswordExample)) {
    //   this.passwordError.html(
    //     "Please use min 6 max 15 characters, at least one letter, one small alphabet, one number and one special character"
    //   );

    //   flag = false;
    // }

    // return flag;

    let flag = true;

    if (
      !(
        this.inputPassword.val().length >= 6 &&
        this.inputPassword.val().length <= 15
      )
    ) {
      $("#collapseOne-1").addClass("show");

      this.passwordError.html("Password must be min 6 and max 15 characters");

      flag = false;
    }

    return flag;
  };

  Address_validate = () => {
    let flag = true;

    if (this.inputAddress.val().length < 5) {
      $("#collapseTwo-1").addClass("show");

      this.inputAddressError.html("Address should be min 5 characters long");

      flag = false;
    }

    return flag;
  };

  City_validate = () => {
    let flag = true;

    var cityExample = /^[a-zA-Z0-9 _.-]*$/;

    if (
      !this.inputCity.val().match(cityExample) ||
      this.inputCity.val().length < 3
    ) {
      $("#collapseTwo-1").addClass("show");
      this.inputCityError.html(
        "City should be min 3 characters long and no special characters",
      );

      flag = false;
    }

    return flag;
  };

  Pincode_validate = () => {
    let flag = true;

    var pincodeExample = /^\d{6}$/;

    if (
      !this.inputPincode.val().match(pincodeExample) ||
      this.inputPincode.val().length < 6
    ) {
      $("#collapseTwo-1").addClass("show");

      this.inputpincodeError.html("Pincode should be 6 digits");

      flag = false;
    }

    return flag;
  };

  // imageSelected_validate = () => {
  //   const inpFile = document.getElementById("inpBusinessImg");

  //   let flag = true;
  //
  //   //let inputFileOneValue = inpFile.files[0];

  //
  //   if (inpFile.files[0] === undefined) {
  //     this.BusinessImageError.html("Please select an image");
  //     flag = false;
  //   } else {
  //     // this.BusinessImageError.html("");
  //   }

  //   return flag;
  // };

  ImageValidate = () => {
    const inpFile = document.getElementById("inpBusinessImg");

    if (!inpFile || inpFile.files[0] === undefined) {
      this.imgSelected = false;

      if (this.vendorStatusFlag) {
        this.imgSelected = true;
        document.getElementById("inpBusinessImgPreview").src = this.savedVendorImg;
        this.img1flag = true;
        return 0;
      }
    } else {
      this.imgSelected = true;
    }

    this.img1flag = true;
    var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
    if (!inpFile || !inpFile.files[0]) {
      this.imgSelected = false;
    } else {
      if (!inpFile.files[0]["name"].match(imgExpression)) {
        this.img1flag = false;
        this.imgSelected = false;
        $(".BusinessImageError").html("Please select an image file");
      } else {
        this.imgSelected = true;
        $(".BusinessImageError").html("");
        // Preview is handled by vendor_image_cropperjs
      }
    }
  };

  Submit_Form = () => {
    //code for submit form(api and ajax)
    // let phoneNumberInput = this.phNoTextField.val();
    // let passwordInput = this.passwordTextField.val();
    this.phoneNumberError.html("");
    this.emailError.html("");

    // this.GSTDetails_page.removeClass("d-none");
    // this.basicDetails_page.addClass("d-none");

    if (!globalThis.userCreated) {
      var added_data =
        this.basicDetailsAndAddressForm.serialize() + "&OTP=" + otp;

      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/VerifyOTPSignUp",
        headers: { Authorization: X_API_KEY },
        data: added_data,
        statusCode: {
          400: function () {
            alert("400 status code! user error");
          },
          500: function () {
            alert("500 status code! server error");
          },
        },
        success: this.phoneExists,
      });
    } else {
      globalThis.prevPhoneNo = this.inputPhoneNumber.val();
      globalThis.prevEmail = this.inputEmail1.val();
      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/VerifyOTPUpdateDetails",
        // data : {
        //     "name" : phoneNumberInput,
        //     "category" : passwordInput
        //       },
        headers: { Authorization: X_API_KEY },

        data: this.basicDetailsAndAddressForm.serialize(),
        statusCode: {
          400: function () {
            alert("400 status code! user error");
          },
          500: function () {
            alert("500 status code! server error");
          },
        },
        success: this.afterDetailsUpdated,
        //  function (res) {
        //
        //
        //   if (res.code == 6) {
        //     this.phoneExists();
        //   }
        // },
        // error: function (res) {
        //
        //   this.phoneExists;
        // },
      });
    }
  };

  uploadBusinessImage = async () => {
    if (this.inpFileOne && this.inpFileOne.src.length > 100) {
      var vendorProfileImage = this.inpFileOne.src;
      this.newEditProductImages = [
        {
          imageFile: vendorProfileImage,
          imageNo: 1,
        },
      ];
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/businessPhotoUpload",
          data: {
            ProductImages: this.newEditProductImages,
            productServiceName: "BusinessImage1",
          },
          headers: { Authorization: X_API_KEY },
          success: (result) => {
            if (typeof result === "string" && result.length > 0) {
              document.getElementById("inpBusinessImgPreview").src = result;
              this.savedVendorImg = result;
            }
            resolve();
          },
          error: resolve,
        });
      });
    } else {
      await new Promise((resolve) => {
        $.ajax({
          type: "GET",
          url: baseURL + "api/Vendor/getVendorDetails",
          headers: { Authorization: X_API_KEY },
          success: (result) => {
            this.savedVendorImg = getVendorBusinessImageUrl(result.Image_URL, 1);
            document.getElementById("inpBusinessImgPreview").src = this.savedVendorImg;
            resolve();
          },
          error: resolve,
        });
      });
    }

    this.otpInputVerify.val("");
    this.otpError.html("");
    this.verifyOTPBtn.removeClass("d-none");
  };

  afterDetailsUpdated = (res) => {
    this.Validate_Email();
    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/AddUpdateAddress",

      headers: { Authorization: X_API_KEY },

      data: this.basicDetailsAndAddressForm.serialize(),
      statusCode: {
        400: function () {
          alert("400 status code! user error");
        },
        500: function () {
          alert("500 status code! server error");
        },
      },
    });
    // this.GSTDetails_page.removeClass("d-none");
    this.vendorCategoriesBox.removeClass("d-none");
    this.basicDetails_page.addClass("d-none");
    this.formstep1.removeClass("current-item");
    this.formstep2.addClass("current-item");
    // this.formstep3.addClass("current-item");
    // this.formstep4.removeClass("current-item");
    this.uploadBusinessImage();
  };

  Validate_Email = () => {
    let userEmail = this.inputEmail1.val();
    $.ajax({
      type: "POST",
      url: baseURL + "api/ZeroBounce/update",
      data: {
        basicEmail: userEmail,
      },
      headers: { Authorization: X_API_KEY },

      success: function (res) {},
    });
  };

  phoneExists = (res) => {
    globalThis.prevPhoneNo = this.inputPhoneNumber.val();
    globalThis.prevEmail = this.inputEmail1.val();

    let vend_id = res.Vendor_ID;
    localStorage.setItem("Vendor_ID", vend_id);

    let retCode = res.Code;

    //

    // if (retCode == 6) {
    //   // this.phoneExists();
    //

    //   this.phoneNumberError.html("Phone Number already exists");
    // } else if (retCode == 7) {
    //   // this.phoneExists();
    //   this.emailError.html("Email already exists");
    // } else {
    //

    this.Validate_Email();

    this.phoneNumberError.html("");
    this.emailError.html("");

    // document.location = "vendor_login";
    globalThis.userCreated = true;

    //this.addressPost(vend_id);
    //this.venId.html(vend_id);//

    this.basicDetails_page.addClass("d-none");
    this.formstep1.removeClass("current-item");
    this.formstep2.addClass("current-item");
    this.vendorCategoriesBox.removeClass("d-none");

    // document.location = "vendor_gst_delivery_details";
    // }
    this.uploadBusinessImage();
    this.sendNewVendorRegisteredEmail(res);
  };

  //addressPost fn is not used
  addressPost = (vend_id) => {
    let input_address = this.inputAddress.val();
    let input_city = this.inputCity.val();
    let input_state = this.inputState.val();
    let input_pincode = this.inputPincode.val();
    let input_vend_id = vend_id;

    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/AddUpdateAddress",

      //data: this.basicDetailsAndAddressForm.serialize(),

      data: {
        in_add: input_address,
        in_city: input_city,
        in_state: input_state,
        in_pin: input_pincode,
        in_ven: input_vend_id,
      },

      headers: { Authorization: X_API_KEY },

      success: function (res) {},
    });
  };

  doVerifyOTP = (e) => {
    e.preventDefault();

    let isOTPValidated = this.verifyOTPFunction();
    if (isOTPValidated) {
      this.OTPSuccess.addClass("text-success");
      this.OTPSuccess.removeClass("text-danger");
      this.OTPSuccess.html("OTP sent ");
      this.OTPInputVerify.prop("disabled", true);
      this.verifyOTPBtn.addClass("d-none");
      this.verifyOTPDetails.addClass("d-none");
      this.submitBtn.removeClass("d-none");
      // this.verifyOtpModal.hide();
      window.$("#verifyOtpModal").modal("hide");

      // setTimeout(demo, 5000);
      this.Submit_Form();
    } else {
      this.OTPSuccess.addClass("text-danger");
      //this.OTPSuccess.removeClass("text-success");
      this.OTPSuccess.html("Invalid OTP");
    }
  };

  verifyOTPFunction = () => {
    let flag = true;
    let OTPExample = /^\d{4}$/;

    if (!this.otpInputVerify.val().match(OTPExample)) {
      flag = false;
    } else {
      if (otp == this.otpInputVerify.val()) {
        flag = true;
      } else {
        flag = false;
      }
    }

    return flag;
  };
  //autoDetectFunction= () => {

  // $.ajax({
  //   url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAHiAUyuPDzNgEEFaP0Ff0udk2cxEs0d8A",
  //   headers: {'Access-Control-Allow-Origin': '*'},
  //   type: "GET",
  //   success: this.initModal,
  //   error: function (result) {
  //
  //   },
  // });

  //}

  //Start of Google Maps Javascript
  initModal = () => {
    var location = new google.maps.LatLng(0, 0);

    var mapProperty = {
      center: location,
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    var map = new google.maps.Map(document.getElementById("map"), mapProperty);

    //Places API
    var marker;
    var places;
    var searchBox = new google.maps.places.SearchBox(
      document.getElementById("pac-input"),
    );
    // map.controls[google.maps.ControlPosition.TOP_CENTER].push(
    //   document.getElementById("pac-input")
    // );

    google.maps.event.addListener(searchBox, "places_changed", () => {
      searchBox.set("map", null);

      places = searchBox.getPlaces();

      marker.setMap(null);
      marker = new google.maps.Marker({
        //position: { lat: 45245, lng: 452435 },
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        position: places[0].geometry.location,
      });

      this.geocodePosition(marker.getPosition());

      google.maps.event.addListener(marker, "dragend", () => {
        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
        $("#latitude").val(marker.getPosition().lat());
        $("#longitude").val(marker.getPosition().lng());
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let pos = {
            lat: places[0].geometry.location.lat(),
            lng: places[0].geometry.location.lng(),
          };

          $("#inputLat").val(pos.lat);
          $("#inputlong").val(pos.lng);

          //

          marker.setPosition(pos);

          map.setCenter(marker.getPosition());
          this.geocodePosition(marker.getPosition());
        });
      }
    });

    //    var bounds = new google.maps.LatLngBounds();
    //

    //    var i, place;
    //    for (i = 0; place = places[i]; i++) {
    //      (function(place) {
    //        var marker = new google.maps.Marker({

    //          position: place.geometry.location
    //        });
    //
    //        marker.bindTo('map', searchBox, 'map');
    //        google.maps.event.addListener(marker, 'map_changed', function() {
    //          if (!this.getMap()) {
    //            this.unbindAll();
    //          }
    //        });
    //        bounds.extend(place.geometry.location);

    //      }(place));

    //    }
    //    map.fitBounds(bounds);
    //    searchBox.set('map', map);
    //    map.setZoom(Math.min(map.getZoom(),18));

    //  });

    //Places API ends

    marker = new google.maps.Marker({
      //position: { lat: 45245, lng: 452435 },
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: location,
    });

    this.geocodePosition(marker.getPosition());

    google.maps.event.addListener(marker, "dragend", () => {
      map.setCenter(marker.getPosition());
      this.geocodePosition(marker.getPosition());
      $("#latitude").val(marker.getPosition().lat());
      $("#longitude").val(marker.getPosition().lng());
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        $("#inputLat").val(pos.lat);
        $("#inputlong").val(pos.lng);

        //

        marker.setPosition(pos);

        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
      });
    }
    //this.initialize();
  };

  geocodePosition = (pos) => {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      {
        latLng: pos,
      },
      function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var address = {};
          var component = results[0].address_components;
          for (var i = 0; i < component.length; i++) {
            // if (component[i].types.includes("locality")) {
            //   var locality = component[i].long_name;
            // }

            // if (component[i].types.includes("administrative_area_level_1")) {
            //   var arealevel1 = component[i].long_name;
            // }

            // if (component[i].types.includes("postal_code")) {
            //   var postal_code = component[i].long_name;
            // }

            //Oysturn Code
            address[`${component[i].types[0]}`] = component[i].long_name;
            //Oysturn Code Ends
          }

          //$("#address-label").html(results[0].formatted_address);

          var ownShortAddress;

          $(".inputAddress").val(results[0].formatted_address);
          $(".inputCity").val(address.locality);
          $(".inputState1").val(address.administrative_area_level_1);
          $("#inputPincode").val(address.postal_code);
        } else {
          $("#address-label").html("Cannot determine address at this location");
        }
      },
    );
  };

  show_vendor_details = (res) => {
    globalThis.userCreated = true;
    // $("#inputBusinessName").attr(res.Business_Name);
    // document.getElementById("inpBusinessImg").fileLabel = "";

    var vendorImgUrl = getVendorBusinessImageUrl(res.Image_URL, 1);
    document.getElementById("inpBusinessImgPreview").src = vendorImgUrl;
    this.savedVendorImg = vendorImgUrl;

    // savedVendorImg = document.getElementById("inpBusinessImgPreview").src;

    // document.getElementById("inpBusinessImgPreview").src =
    //   "https://Locaso-data-pro.s3.ap-south-1.amazonaws.com/Vendor/252_gdfg+dfsg+dfs/Document+Images/Business+Image.png";

    document.getElementById("inputBusinessName").value = res.Business_Name;
    document.getElementById("inputContactPersonName").value =
      res.Contact_Person;
    document.getElementById("inputPhoneNumber").value = res.Phone_Number;
    document.getElementById("inputEmail1").value = res.Email_Address;
    document.getElementById("inputPassword").disabled = true;
    globalThis.prevPhoneNo = this.inputPhoneNumber.val();
    globalThis.prevEmail = this.inputEmail1.val();
  };

  GetAddress = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/GetAddress",
      headers: { Authorization: X_API_KEY },

      success: this.doDisplayAddress,
    });
  };
  doDisplayAddress = (res) => {
    $("#VendorAccountAddress").empty();

    var item = ` <div class="card card-locaso-info ml-3 mb-2 mt-6">
    <div class="card-body">
        <h5 class="card-title">ADDRESS</h5>
        <p class="card-text">Manage your Addresse</p>
    </div>
</div>


<div class="row">
    <div class="col-sm-6">
        <div class="card ml-3 border border-3 mb-1">
            <div class="card-body">
                <h5 class="card-title">Current Location</h5>
                <p class="card-text">${res.Address_Line_1}</p>


                <div class="row d-none" id="EditDeleteBtnDesktop">
                    <div class="col d-flex justify-content-start "> <button class="btn btn-sm " type="button" style="color: #ff385c;">Edit</button>
                    </div>
                    <div class="col  d-flex justify-content-end"> <button class="btn btn-sm" type="button" style="color: #ff385c;">Delete</button>
                    </div>
                </div>

                <div class="col d-flex justify-content-start"> <button class="btn btn-sm customerAccountAddressEdit locationModalAccountEdit" type="button" style="color: #ff385c;" data-bs-toggle="modal" data-bs-target="#locationModalAccountCallEdit">Edit
                <input type="hidden" name="customerAddressIdAccount" value="${res.Vendor_Address_ID}" />
            </button>
        </div>
            </div>
        </div>
    </div>
    
</div>`;

    $("#VendorAccountAddress").append(item);

    // $(".inputAddressNameChangeAccountEdit").val(res.Address_Name);
    $(".inputAddress").val(res.Address_Line_1);
    $("#inputLandmark").val(res.Landmark);
    $(".inputCity").val(res.City);
    $(".inputState1").val(res.State);
    $("#inputPincode").val(res.Pincode);
    oldLat = res.lat;
    oldLong = res.lon;

    this.editAddress();
    // $(".locationModalAccountEdit").on("click", this.editAddress);
    // $(".saveAddressBtn").on("click", this.saveNewAddress);
  };

  editAddress = () => {
    var id = `map`;
    var lat = parseFloat(oldLat) || 0;
    var lon = parseFloat(oldLong) || 0;
    //this.autoDetectModal.show();

    // var lat1 = marker.latLng.lat();
    // var lng1 = marker.latLng.lng();

    var location = new google.maps.LatLng(lat, lon);

    var mapProperty = {
      center: location,
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    var map = new google.maps.Map(
      document.getElementById(`${id}`),
      mapProperty,
    );

    //Places API
    var marker;
    var places;
    var searchBox = new google.maps.places.SearchBox(
      document.getElementById("pac-input"),
    );
    // map.controls[google.maps.ControlPosition.TOP_CENTER].push(
    //   document.getElementById("pac-input")
    // );

    google.maps.event.addListener(searchBox, "places_changed", () => {
      searchBox.set("map", null);

      places = searchBox.getPlaces();

      marker.setMap(null);
      marker = new google.maps.Marker({
        //position: { lat: 45245, lng: 452435 },
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        position: places[0].geometry.location,
      });

      this.geocodePosition(marker.getPosition());

      google.maps.event.addListener(marker, "dragend", () => {
        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
        $("#inputLat").val(marker.getPosition().lat());
        $("#inputlong").val(marker.getPosition().lng());
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let pos = {
            lat: places[0].geometry.location.lat(),
            lng: places[0].geometry.location.lng(),
          };

          $("#inputLat").val(pos.lat);
          $("#inputlong").val(pos.lng);

          //

          marker.setPosition(pos);

          map.setCenter(marker.getPosition());
          this.geocodePosition(marker.getPosition());
        });
      }
    });

    //    var bounds = new google.maps.LatLngBounds();
    //

    //    var i, place;
    //    for (i = 0; place = places[i]; i++) {
    //      (function(place) {
    //        var marker = new google.maps.Marker({

    //          position: place.geometry.location
    //        });
    //
    //        marker.bindTo('map', searchBox, 'map');
    //        google.maps.event.addListener(marker, 'map_changed', function() {
    //          if (!this.getMap()) {
    //            this.unbindAll();
    //          }
    //        });
    //        bounds.extend(place.geometry.location);

    //      }(place));

    //    }
    //    map.fitBounds(bounds);
    //    searchBox.set('map', map);
    //    map.setZoom(Math.min(map.getZoom(),18));

    //  });

    //Places API ends

    marker = new google.maps.Marker({
      //position: { lat: 45245, lng: 452435 },
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: location,
    });

    this.geocodePosition(marker.getPosition());

    google.maps.event.addListener(marker, "dragend", () => {
      map.setCenter(marker.getPosition());
      this.geocodePosition(marker.getPosition());
      $("#inputLat").val(marker.getPosition().lat());
      $("#inputlong").val(marker.getPosition().lng());
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let pos = {
          lat: lat,
          lng: lon,
        };

        $("#inputLat").val(pos.lat);
        $("#inputlong").val(pos.lng);

        //

        marker.setPosition(pos);

        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
      });
    }
    //this.initialize();
  };

  doResendOTPAction = (e) => {
    e.preventDefault();
    this.doFormAction(e);
    $("#otpResendMsg").html("New OTP has been sent to you.");
    setTimeout(() => {
      $("#otpResendMsg").html("");
    }, 4000);
  };

  sendNewVendorRegisteredEmail = async ({ user }) => {
    const Business_Name = user.Business_Name;
    const Email_Address = user.Email_Address;
    const Phone_Number = user.Phone_Number;
    const Regis_Vend_ID = user.Vendor_ID;
    const Regis_time = user.createdAt;

    if (true) {
      var BodyHtmlForAdmin = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
      <html>
        <head>
          <!-- Compiled with Bootstrap Email version: 1.3.1 -->
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta http-equiv="x-ua-compatible" content="ie=edge">
          <meta name="x-apple-disable-message-reformatting">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
          <style type="text/css">
            body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}*[class=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
          </style>
        </head>
        <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
            <tbody>
              <tr>
                <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                  <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                          <!--[if (gte mso 9)|(IE)]>
                            <table align="center" role="presentation">
                              <tbody>
                                <tr>
                                  <td width="600">
                          <![endif]-->
                          <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                            <tbody>
                              <tr>
                                <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <img class="w-16" src="https://Locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/LocasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div class="space-y-4">
                                    <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">${Business_Name} has STARTED registration as a new Seller</h1>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">Log in to your Admin dashboard to verify andupdate the status of the vendor.</p>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="btn btn-red-500 rounded-full px-6 w-full w-lg-48" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 9999px; border-collapse: separate !important; width: 192px;" width="192">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 16px; border-radius: 9999px; width: 192px; margin: 0;" align="center" bgcolor="#dc3545" width="192">
                                            <a href="${
                                              baseURL +
                                              "Locaso-admin-api/Login/index"
                                            }" style="color: #ffffff; font-size: 16px; font-family: Helvetica, Arial, sans-serif; text-decoration: none; border-radius: 9999px; line-height: 20px; display: block; font-weight: normal; white-space: nowrap; background-color: #3335ec; padding: 8px 24px; border: 1px solid #3335ec;">Dashboard</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                          <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Vendor Details</h3>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Vendor ID #${Regis_Vend_ID}</p>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Seller Email :${Email_Address}</p>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Seller Phone :${Phone_Number}</p>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Seller Registration Time :${Regis_time}</p>
                                          <table class="p-2 w-full" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              ${""}
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="https://bootstrapemail.com" style="color: #0d6efd;"><span class="_cf_email_" data-cfemail="40082930032f3230002538212d302c256e232f2d">vendor.support@Locaso.com</span></a>.</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (gte mso 9)|(IE)]>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                          <![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
      </html>`;
      $.ajax({
        url: baseURL + "api/AmazonSesSmtp/sendEmail",
        type: "POST",
        data: {
          SenderAddress: "vendor.support@Locaso.com",
          ReceiverAddress: "vendor.support@Locaso.com",
          Subject: `NEW SELLER - new supplier has STARTED registration on Locaso`,
          BodyText: `VENDOR REGISTRATION DETAILS`,
          BodyHtml: BodyHtmlForAdmin,
        },
        success: (result) => {},
        error: (error) => {},
      });
    }
  };
}

